<template>
	<div>
		<HeaderMenu></HeaderMenu>
		<div class="main_content">
			<section class="bread_crumb">
				<div class="container">
					<ul>
						<li><router-link v-bind:to="'/'">Home</router-link></li>
						<li>Contact Us</li>
					</ul>
				</div>
			</section>
			<div class="mission_banner_wrapper custom-banner-section">
				<div class="about_main_image">
					<img src="../../assets/images/contact-us.png" alt="Contact us" />

					<div class="about_main_title">
						<h4>CONTACT US</h4>
					</div>
				</div>
				<div class="">
				</div>
			</div>
			<div class="contact_form_wrap">
				<div class="container">
					<h4>Please provide the following information<br>so that we may assist you.</h4>
					<div class="row">
						<div class="col-lg-8 col-md-6">
							<div v-if="success_status" class="alert alert-success alert-dismissible fade show" role="alert">
	                            <strong>Your request has been submitted to the admin</strong>
	                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
	                                <span aria-hidden="true">&times;</span>
	                            </button>
	                        </div>
							<div class="contact_right_form">
								<form v-on:submit.prevent="contact_us">
									<div class="row">
										<div class="col-md-6">
											<input type="text" v-model="name"  name="name" placeholder="Name*" class="form-control" v-bind:class="{required : isInputValid(errors.name)}">
										</div>
										<div class="col-md-6">
											<input type="text" v-model="title"  name="title" class="form-control" placeholder="Title">
										</div>
										<div class="col-md-6">
											<input type="text" v-model="workplace"  name="workplace" placeholder="Work Place" class="form-control">
										</div>
										<div class="col-md-6">
											<input type="tel" v-model="contact_number"  name="contact_number"  placeholder="Phone Number" class="form-control" v-bind:class="{required : isInputValid(errors.contact_number)}">
										</div>
										<div class="col-md-12">
											<input type="email" v-model="email"  name="email" placeholder="Email*" class="form-control"  v-bind:class="{required : isInputValid(errors.email)}">
										</div>
										<div class="col-md-12">
											<textarea v-model="message"  name="message" class="form-control" rows="3" placeholder="Message" v-bind:class="{required : isInputValid(errors.message)}"></textarea>
										</div>
										<div class="col-md-12">

											<input type="submit" name="submit" value="Send Message" v-if="!processing" class="send_btn read_more">
	                                    	<input type="submit" name="submit" value="Wait..." v-if="processing" class="send_btn read_more" disabled>
										</div>
									</div>
								</form>
							</div>
						</div>
						<div class="col-lg-4 col-md-6">
							<div class="contact_info_right">
								<div class="contact_sidebar" v-if="content!=null" v-html="content.contact_info_eng"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="contact_business_info"  v-if="content!=null && content.members_info!=null">
				<div class="row">
					<div class="col-md-4"  v-for="member in content.members_info">
						<h4>{{member.title_eng}}</h4>
						<h5>{{member.name_eng}}</h5>
						<span><a :href="'mailto:'+member.email">{{member.email}}</a></span>
					</div>
				</div>
			</div>
			<div class="contact_map">
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.4815457874447!2d46.657978861901846!3d24.74467341238962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2ee32ab18f0b13%3A0x3e19298cd9d7a8b0!2z2YbZhdinINin2YTYt9io2YrYqSBOYW1hIE1lZGljYWw!5e0!3m2!1sen!2ssa!4v1662104945812!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


				<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1958676.5542499907!2d45.18084198579058!3d25.17524948790058!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1654149835635!5m2!1sen!2sin" width="600" height="450" style="border:0; display: none;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
	export default {
		data(){
	        this.get_page_content();
	        return {
	            content:null,
	            current_locale:this.$i18n_global.locale,
	            name:null,
	            title:null,
	            workplace:null,
	            contact_number:null,
	            email:null,
	            message:null,
	            processing:null,
	            success_status:false,
	            errors:[],
	        }
	    },
	    components:{
	        HeaderMenu:HeaderMenu
	    },
	    methods:{
	        async get_page_content() {
	            var _self = this;
	            await axios.post(_self.$hostname+'/api/contact-settings')
	            .then((res) => {
	                var response = res.data.data;
	                console.log(response,"response");
	                _self.content = response;
	            })
	            .catch((error) => {
	                console.log(error.response.data.error);
	                return false;
	            })
	            return false;
	        },
	        isInputValid(input){
	            return (typeof input != "undefined" && input!="");
	        },
	        getError(input){
	            return (typeof input != "undefined" && input!="") ? input[0] : '';
	        },
	        contact_us() {
	            var _self = this;
	            _self.errors = [];
	            _self.success_status = false;
	            this.processing = true;
	            this.$axios_global.post(_self.$hostname+'/api/contact',
	            {
	                name:_self.name,
	                title:_self.title,
	                email:_self.email,
	                contact_number:_self.contact_number,
	                workplace:_self.workplace,
	                message:_self.message,
	            })
	            .then((res) => {
	                _self.processing = false;
	                _self.success_status = true;
	                _self.name=null;
	                _self.email=null;
	                _self.contact_number=null;
	                _self.workplace=null;
	                _self.program=null;
	                router.push({name: 'Thankyou'})
	            })
	            .catch((error) => {
	                _self.processing = false;
	                _self.errors = error.response.data;
	                return false;
	            })
	        }
	    }
	}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ContactUs.vue